import React, { createContext, useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const LastLocationContext = createContext(null);

export function LastLocationProvider({ children }) {
  const location = useLocation();
  const lastLocationRef = useRef(null);
  const currentLocationRef = useRef(location);

  useEffect(() => {
    // Save the previous location before updating to current
    if (currentLocationRef.current.pathname !== location.pathname) {
      lastLocationRef.current = currentLocationRef.current;
      currentLocationRef.current = location;
    }
  }, [location]);

  return (
    <LastLocationContext.Provider value={lastLocationRef.current}>
      {children}
    </LastLocationContext.Provider>
  );
}

export function useLastLocation() {
  return useContext(LastLocationContext);
}
